import { create } from './deferred';
import type { IPackageType } from '@eureka/services/src/apis/common.api.types';
import { CommonApis } from '@eureka/services/src/apis/common.api'
import _ from 'lodash';

export const packageInfoDeferred = create<IPackageType[]>();

export const getPackageInfo = () => CommonApis.getUserPackageType().then(packages => {
    packageInfoDeferred.resolve(packages)
    return packages;
})

getPackageInfo();

export const getIfHasTrialPackage = (packages: IPackageType[]) => {
    return _.some(packages, item => _.has(item, 'trial_package_left_days'));
}
